import axios from "axios";

// Generic currency converter
export async function convertCurrency(amount, fromCurrency) {
  try {
    const toCurrency = localStorage.getItem('cur');
    const res = await axios.get(
      `${process.env.REACT_APP_CURRENCY_API}${fromCurrency.toLowerCase()}.json`
    );

    const rate = res.data[fromCurrency.toLowerCase()][toCurrency.toLowerCase()];
    if (!rate) throw new Error(`Rate not found for ${fromCurrency} -> ${toCurrency}`);

    return (parseFloat(amount) * rate).toFixed(2);
  } catch (err) {
    console.error("Error fetching currency conversion", err);
    return null;
  }
}


// Format number as currency string
export function formatCurrency(amount, currency = "USD") {
  if (amount == null || isNaN(amount)) return "";

  const formattedNumber = amount
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return `${currency}. ${formattedNumber}`;
}
